import { jsx as _jsx } from "react/jsx-runtime";
import Competitions, { allColumns } from "./Competitions";
import { applyPropertyControls, ControlType } from "../../property-controls";
import { columnTitleMessages } from ".";
import { contentBoxPropertyControls } from "../../ContentBox";
import { FormattedMessage } from "react-intl";
import { isNotNull } from "../../utils";
const columnNames = allColumns
    .map(c => c.field)
    .filter(isNotNull);
const columnTitles = allColumns
    .map(c => typeof c.field === "string"
    ? columnTitleMessages[c.field]
    : c.field?.join(", "))
    .filter(isNotNull);
applyPropertyControls(Competitions, {
    visibleColumns: {
        type: ControlType.Array,
        title: (_jsx(FormattedMessage, { id: "dploy.grid.competitions.visibleColumns.label", defaultMessage: "Visible columns" })),
        propertyControl: {
            type: ControlType.Enum,
            title: "",
            options: columnNames,
            optionTitles: columnTitles
        },
        defaultValue: columnNames,
        coerce: (_, { rawColumns }) => rawColumns
            ?.toLowerCase()
            .split("\n")
            .map(n => {
            if (n) {
                return columnNames.find(name => name.toLowerCase() === n);
            }
            return null;
        })
            .filter(isNotNull)
    },
    scrollable: {
        type: ControlType.Boolean,
        title: (_jsx(FormattedMessage, { id: "dploy.grid.competitions.scrollable.label", defaultMessage: "Scrollable table" })),
        defaultValue: false,
        coerce: value => (String(value) === "1" ? true : false)
    },
    boxProps: contentBoxPropertyControls
});
export default Competitions;
//# sourceMappingURL=property-controls.js.map